import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { APPLYING_PAYMENT, APPLY_PAYMENT, GETTING_PAYMENTS, GET_PAYMENTS, PAYMENTS_ERROR } from "../types"

export const fetchPayments = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/payments?expand=transaction,fee,application,createdBy,invoice,invoiceAssignment`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_PAYMENTS,
            payload: true
        })

        const response = await axios.get(url, { headers })

        dispatch({
            type: GET_PAYMENTS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: PAYMENTS_ERROR,
            error
        })
    }
}

export const applyPayment = (paymentId) => async (dispatch) => {    
    try{
        const headers = authHeader()
        console.log('the payment being applied', paymentId)
        dispatch({
            type: APPLYING_PAYMENT,
            payload: paymentId
        })
        // const response = await axios.get(`${baseUrl}/payments/apply/${paymentId}`, { headers })
        
        // dispatch({
        //     type: APPLY_PAYMENT,
        //     payload: response.data.data
        // })
        
    }
    catch(error){
        dispatch({
            type: PAYMENTS_ERROR,
            error
        })
    }
}

export const clearAppliedPayment = () => async (dispatch) => {    
    dispatch({
        type: APPLY_PAYMENT,
        payload: null
    })
}
